import { isInternationalTimezone } from "utils/AuthUtil";
import { isValidEmail, isValidMobile, is_empty } from "utils/validations";

export const VALIDATION_MESSAGES = {
  REQUIRED: "Required",
  INVALID: "Invalid",
  INVALID_EMAIL: "Invalid Email",
  INVALID_PHONE_NUMBER: "Invalid Phone Number",
};

export const UNSELECTED_INDEX_SENTINELS = [0, "0"];

/**
 * Helper to determine if a value is empty or unselected.
 * Treats null, undefined, empty strings, and index sentinels (0, "0") as empty.
 *
 * @param {*} value - The input value to validate
 * @returns {boolean} True if empty or unselected
 */
export const isEmptyValue = (value) => {
  return is_empty(value) || UNSELECTED_INDEX_SENTINELS.includes(value);
};

export const validatePrice = (price, allValues) => {
  const { selected_quantity } = allValues;
  if (selected_quantity * price < 1) return VALIDATION_MESSAGES.INVALID;
};

export const required = (value) => {
  if (is_empty(value)) return VALIDATION_MESSAGES.REQUIRED;
};

/**
 * Validates date index selection for appointment slots.
 *
 * Note on selection semantics:
 * In zero-indexed arrays, index 0 is a valid position. However, legacy dropdown options
 * use 0 or "0" as an unselected placeholder sentinel value. This validator uses `isEmptyValue(value)`
 * to check for `null`/`undefined`/`""` as well as `0`/`"0"` sentinels, delegating error message generation
 * to `required()`. For new components, prefer using an explicit `selectedIndex === null` sentinel.
 *
 * @param {*} value - The date index value from the form
 * @returns {string|undefined} Validation error message or undefined if valid
 */
export const validateDateIndex = (value) => {
  if (isEmptyValue(value)) return required(null);
};

export const validateEmail = (email) => {
  if (!isValidEmail(email)) return VALIDATION_MESSAGES.INVALID_EMAIL;
};

export const validatePhoneNumber = (phoneNumber, allValues = {}) => {
  if (!phoneNumber) return VALIDATION_MESSAGES.REQUIRED;

  const countryCode = allValues?.country_code || "+91";
  const dialCode = countryCode.replace("+", "");

  const cleanedPhone = (phoneNumber || "")
    .replace(/\+/g, "")
    .replace(/\s/g, "")
    .replace(/-/g, "");

  let _phone = cleanedPhone;
  if (dialCode && cleanedPhone.startsWith(dialCode)) {
    _phone = cleanedPhone.slice(dialCode.length);
  }

  if (!isInternationalTimezone() && !isValidMobile(countryCode, _phone)) {
    return VALIDATION_MESSAGES.INVALID_PHONE_NUMBER;
  }
};
